import styled from "@emotion/styled";
import { media } from "../../components/Window/themes";
const textAndLabelStyle = `
  max-width: 200px;
  overflow-wrap: break-word;
  ${media.medium} {
    font-size: 0.9rem !important;
  }
`;
const User = {
    Wrapper: styled.header `
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    color: ${({ theme }) => theme.color.text};
    margin-left: 1em;
    position: relative;
    ${media.medium} {
      margin-left: 0em;
    }
  `,
    Text: styled.p(textAndLabelStyle),
    Label: styled.label(textAndLabelStyle),
    ModeratorBadge: styled.span `
    color: red;
    font-size: 0.6em;
    position: absolute;
    top: 10%;
    left: 85%;
  `,
};
export default User;
//# sourceMappingURL=User.styled.js.map